export default [
  {
    path: "/institution",
    name: "institutions",
    component: () => import("@/views/apps-and-pages/Institutions.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/accounts",
    name: "accounts",
    component: () => import("@/views/apps-and-pages/Accounts.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/analysis",
    name: "analysis",
    component: () => import("@/views/apps-and-pages/Analysis.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/variables",
    name: "variables",
    component: () => import("@/views/apps-and-pages/Variables.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/statistics",
    name: "statistics",
    component: () => import("@/views/apps-and-pages/Statistics.vue"),
    meta: {
      authRequired: true,
    },
  },
]
